function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300px",
    width: "300px",
    fill: "#000000",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    d: "m 18,958.36216 c -1.6879,0.0119 -2.9897,1.69053 -3,3 l 0,82.00004 c 2e-4,1.5707 1.4293,2.9998 3,3 l 64,0 c 1.5707,-2e-4 2.9998,-1.4293 3,-3 l 0,-64.00004 c 0,-0.78611 -0.3201,-1.56815 -0.875,-2.125 l -18,-18 c -0.5569,-0.55488 -1.3389,-0.87689 -2.125,-0.875 z m 3,6 40,0 0,15 c 2e-4,1.57076 1.4293,2.99985 3,3 l 15,0 0,58.00004 -58,0 z m 46,4.21875 7.7812,7.78125 -7.7812,0 z M 29,992.3622 c -1.6568,0 -3,1.3431 -3,3 0,1.6568 1.3432,3 3,3 l 34,0 c 1.6568,0 3,-1.3432 3,-3 0,-1.6569 -1.3432,-3 -3,-3 z m 0,16 c -1.6568,0 -3,1.3431 -3,3 0,1.6568 1.3432,3 3,3 l 42,0 c 1.6569,0 3,-1.3432 3,-3 0,-1.6569 -1.3431,-3 -3,-3 z m 0,16 c -1.6568,0 -3,1.3431 -3,3 0,1.6568 1.3432,3 3,3 l 42,0 c 1.6569,0 3,-1.3432 3,-3 0,-1.6569 -1.3431,-3 -3,-3 z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none",
    visibility: "visible",
    display: "inline"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.7b553f7f280ea6baa385413a25531927.svg";
export { ForwardRef as ReactComponent };